import $ from 'jquery';
import mapboxgl from '!mapbox-gl';

import { changeExaggeration, clearMarkers, defaultParcellaireColor, flyTo, getPageData, initLightboxes, map, mapInitialized, mapMarkers } from './main';
import { $Elements, Classes } from '../global/constants';

export function regionEnter() {

	if(map) {

		if(mapInitialized) {
			initMarkers();
		}
		else {
			$Elements.document.on('map.initialized', initMarkers);
		}
	}
}

export function regionLeave() {
	clearMarkers();
}

async function initMarkers() {

	const data = getPageData();

	if(data) {

		if(data.properties) {

			for(const parcellaire of data.properties.parcellaires) {
				map.setPaintProperty(parcellaire, 'fill-opacity', 0);
				map.setPaintProperty(parcellaire, 'fill-color', defaultParcellaireColor);
			}

			for(const marker of data.properties.markers) {

				const markerElement = $(marker.marker);

				mapMarkers.push(new mapboxgl.Marker({
					element: markerElement[0],
					anchor: marker.position,
				}).setLngLat(marker.coordinates).addTo(map));

				map.on('moveend', () => markerElement.addClass(Classes.active));
			}
		}

		initLightboxes();

		if(data.region) {

			await flyTo({
				center: data.region.coordinates,
				zoom: data.region.zoom,
				pitch: 0,
				bearing: 0,
				duration: data.region.duration,
			});

			changeExaggeration(data.region.exaggeration);
		}
	}
}
